/**
 * Oral Arguments Search Hook
 * Hook for Oral Arguments search functionality
 */

import { type OralArgumentsResponse } from '../../types';

import { useCourtSearch } from './useBaseCourtApi';

/**
 * Hook for Oral Arguments search functionality
 */
export const useOralArgumentsSearch = (
  initialQuery: string = '',
  exactMatch: boolean = true
) => {
  const searchHook = useCourtSearch<OralArgumentsResponse>({
    searchType: 'oa',
    queryKeyPrefix: 'oral-arguments-search-v2',
    initialQuery,
    exactMatch,
  });

  return {
    oralArgumentsResults: searchHook.results,
    searchQuery: searchHook.searchQuery,
    sortOption: searchHook.sortOption,

    isSearching: searchHook.isSearching,
    isAnyLoading: searchHook.isAnyLoading,
    hasResults: searchHook.hasResults,
    hasError: searchHook.hasError,
    generalError: searchHook.generalError,
    isTokenLoading: searchHook.isTokenLoading,
    isPaginationLoading: searchHook.isPaginationLoading,

    triggerCombinedSearch: searchHook.triggerCombinedSearch,
    setSortOption: searchHook.setSortOption,
    updateOralArgumentsResults: searchHook.updateResults,
    setPaginationLoading: searchHook.setPaginationLoading,
    setSearchExecuted: searchHook.setSearchExecuted,

    error: searchHook.error,
    data: searchHook.data,
    refetch: searchHook.refetch,
  };
};
